import { FrameFactories, FrameViews } from "@com.mgmtp.a12.client/client-core/lib/core/frame";

import {
	APPLICATION_FRAME,
	DASHBOARD,
	MASTER_DETAIL,
	PROCESS_MASTER_DETAIL,
	STAMMDATEN_MASTER_DETAIL
} from "../../utilities/variables/layoutNames";

import { CustomApplicationFrameLayout } from "./customApplicationFrameLayout";
import { CustomMasterDetailLayout } from "./customMasterDetailLayout";
import { DashboardLayout } from "./dashboardLayout";
import { ProcessLayout } from "./processLayout";
import { StammdatenMasterDetailLayout } from "./stammdatenLayout";

export const customLayoutProvider: FrameViews.LayoutProvider = (name: string) => {
	switch (name) {
		case APPLICATION_FRAME: // hardcoded layout name taken from app model and client defaults
			return CustomApplicationFrameLayout;
		case MASTER_DETAIL: // hardcoded layout name taken from app model and client defaults
			return CustomMasterDetailLayout;
		case PROCESS_MASTER_DETAIL:
			return ProcessLayout;
		case STAMMDATEN_MASTER_DETAIL:
			return StammdatenMasterDetailLayout;
		case DASHBOARD:
			return DashboardLayout;
		default:
			return FrameFactories.layoutProvider(name);
	}
};
